import { OffsetPaginationInput } from 'dy-frontend-http-repository/lib/data/inputs';
import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { TimeTrackingEntrySortField } from 'dy-frontend-http-repository/lib/modules/CoreUser/inputs';
import { TaskTimeTrackingEntryResource } from 'dy-frontend-http-repository/lib/modules/CoreUser/resources';
import repository from 'dy-frontend-http-repository/lib/repository';

import domain from './domain';

// Fetch task time tracking entries
export const fetchTaskTimeTrackingEntries = domain.createEffect<
    { id: ID; pagination: OffsetPaginationInput<TimeTrackingEntrySortField> },
    CollectionResource<TaskTimeTrackingEntryResource, TimeTrackingEntrySortField>
>({
    name: 'fetchTaskTimeTrackingEntries',
    handler: async ({ id, pagination }) => {
        return await repository.coreUser().getTimeTrackingEntries(id, pagination);
    },
});
